import React, { useState } from 'react'

import { Modal } from '@components/modals'

interface SessionNameEditorProps {
  isVisible: boolean
  sessionId: string
  sessionName: string
  onUpdateSessionName: (arg: string) => void
  toggleModal: (arg: boolean) => void
}

function SessionNameEditor({
  isVisible,
  sessionId,
  sessionName,
  onUpdateSessionName,
  toggleModal,
}: SessionNameEditorProps) {
  const [name, setName] = useState(sessionName || '')

  return (
    <Modal
      toggleModal={(res) => toggleModal(res)}
      isVisible={isVisible}
      title="Session Details"
      closeButtonText="Connect →"
      modalWidth="max-w-xl"
      theme={{
        textColor: 'text-mainColour',
        mainBg: 'bg-tertiaryColour',
        secondaryBg: 'bg-neutralColour',
      }}
      hasHeaderControl
      noMainControls
    >
      <div className="py-4 text-mainColour">
        <div className="flex items-center gap-5 pt-2">
          <p className="text-subHeading">Session ID: </p>
          <p className="text-subHeading">{sessionId}</p>
        </div>

        <div className="pt-2 text-left">
          <span className="text-subHeading">Session Name (optional)</span>
          <input
            type="text"
            name="sessionName"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="my-2 w-full rounded border-none bg-gray-300 px-6 py-3 text-default focus:ring-0"
          />
        </div>
        <button
          type="button"
          className="mt-5 flex w-full items-center justify-center rounded bg-gradient py-3 text-center text-subHeading text-white"
          onClick={() => onUpdateSessionName(name)}
        >
          Save
        </button>
      </div>
    </Modal>
  )
}

export default SessionNameEditor
